import React from "react";

export const OnboardingTitle = ({ title, className = "" }: { title: string; className?: string }) => {
  return <h2 className={`text-[1.438rem] font-medium text-center mt-5 mb-8 ${className}`}>{title}</h2>;
};
